import React from 'react';
import PropTypes from 'prop-types';
import ArrowUpIcon from '@tradera/tradera-ui/icons/up.svg?jsx';

const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

const ScrollToTopButton = ({ onClick = null }) => (
    <div className="d-flex py-3 justify-content-center">
        <a
            role="button"
            className="btn btn-fluid btn-toggle btn--icon-fixed col-2"
            onClick={() => {
                if (onClick != null) onClick();
                handleClick();
            }}>
            <ArrowUpIcon className="icon icon-before" />
            <span className="ml-3 d-inline">Till toppen</span>
        </a>
    </div>
);

ScrollToTopButton.propTypes = {
    onClick: PropTypes.func
};

export default ScrollToTopButton;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/shared/scroll-to-top-button.jsx